module.exports = __webpack_public_path__ + "static/media/afternoon.2eacabbc.jpg";